import React from "react"
import { Calendar } from "lucide-react"
import { cn } from "../../../../../lib"
import { t } from "i18next"
import { useTranslation } from "react-i18next"

const cards = [
  { key: "admin.straight", color: "blue" },
  { key: "admin.recommended", color: "orange" },
  { key: "admin.cheap", color: "lightBlue" },
  { key: "admin.fast", color: "red" },
  { key: "admin.early", color: "green" },
]

const colorClasses = {
  blue: "after:from-dark-blue after:to-dark-blue/30 text-dark-blue",
  lightBlue: "after:from-light-blue after:to-light-blue/30 text-light-blue",
  orange: "after:from-light-orange after:to-light-orange/30 text-light-orange",
  red: "after:from-dark-red after:to-dark-red/30 text-dark-red",
  green: "after:from-second-light-green after:to-second-light-green/30 text-second-light-green",
}

const PricingPanel = () => {
  const { t } = useTranslation()

  return (
    <div className="w-full bg-gray-100">
      <div className="mx-auto bg-white rounded-lg shadow-sm p-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4 lg:gap-14 items-start">
          <div className="flex gap-6 flex-wrap">
            {cards.map((card, index) => {
              const { key } = card
              const colors = colorClasses[card.color]

              return (
                <div
                  key={key}
                  className={cn(
                    "relative flex flex-col flex-1 min-w-[140px] max-w-[200px] pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-1 after:bg-gradient-to-r after:rounded",
                    colors
                  )}
                >
                  <span className="font-medium text-base">{t(key)}</span>
                  <span className="text-light-gray text-sm mt-0.5">178€ / 4h</span>
                </div>
              )
            })}
          </div>

          <button className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap w-full lg:w-auto justify-center lg:justify-start">
            <Calendar className="w-5 h-5 text-dark-gray" />
            <span className="text-dark-gray">{t("admin.price_calendar")}</span>
            <svg
              className="w-4 h-4 text-dark-gray"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default PricingPanel
